import { render, staticRenderFns } from "./AddPrices.vue?vue&type=template&id=15f98302&scoped=true&"
import script from "./AddPrices.vue?vue&type=script&lang=js&"
export * from "./AddPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f98302",
  null
  
)

export default component.exports